import SidebarSection, { type SectionItem } from '../SidebarSection';
import TeamsSidebarSection from './TeamsSidebarSection';

interface Props {
    name?: string;
    numberOfUsers?: number;
    users?: string[];
    numberOfFleets?: number;
    fleets?: string[];
    teamInfo: SectionItem[];
    isLoading?: boolean;
}

const SystemTeamsSidebarContent = ({
    name,
    numberOfUsers,
    users,
    numberOfFleets,
    fleets,
    teamInfo,
    isLoading,
}: Props) => (
    <div className='Sidebar__content'>
        <h4 className='Sidebar__name' data-testid='system-teams-sidebar-name'>
            {name}
        </h4>
        <TeamsSidebarSection
            header='Users'
            icon='user'
            items={users ?? []}
            isLoading={isLoading}
            count={numberOfUsers}
        />
        <TeamsSidebarSection
            header='Fleets'
            icon='vehicle'
            items={fleets ?? []}
            isLoading={isLoading}
            count={numberOfFleets}
        />
        <SidebarSection title='System' items={teamInfo} />
    </div>
);

export default SystemTeamsSidebarContent;
